import { Carousel } from '../carousel/Carousel';
import { ScrollableDocument } from './ScrollableDocument';
import React, { useMemo, useState } from 'react';
import { i18n } from 'core/i18n';
import { base64ToBlob, downloadAsFile } from 'utilities/APIRequestHelper';

const { FormattedText } = i18n;

export const DocumentsCarousel = ({
    documentsList,
    currentDocumentIndex,
    pdfContainerRef,
    recordTagPrecontractualModal,
    onScroll,
}) => {
    const [showIconsBoxes, setShowIconsBoxes] = useState(documentsList.map(() => false));
    const showIconsBox = useMemo(() => showIconsBoxes[currentDocumentIndex], [showIconsBoxes, currentDocumentIndex]);
    const currentDocumentPdfFile = documentsList[currentDocumentIndex].file
    const fileName = documentsList[currentDocumentIndex].fileName

    const handleDownload = e => {
        e.preventDefault();
        downloadAsFile(
            base64ToBlob(currentDocumentPdfFile),
            'application/pdf',
            `${fileName}.pdf`
        );
        recordTagPrecontractualModal('descargar');
    };

    const handlePrintPdf = e => {
        e.preventDefault();
        const blob = new Blob([base64ToBlob(currentDocumentPdfFile)], {
            type: 'application/pdf',
        });
        const blobURL = window.URL.createObjectURL(blob);
        const noLocationWithScrollAndMenu = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,';
        const pdfWindowSize = 'resizable,screenX=50,screenY=50,width=850,height=1050';
        const pdfWindowParams = noLocationWithScrollAndMenu + pdfWindowSize;
        const pdfWindow = window.open(blobURL, '', pdfWindowParams);
        pdfWindow.print();
        recordTagPrecontractualModal('imprimir');
    };
    const handleScroll = ({ documentIndex, hasScrolledToBottom, hasScrolledOutsideOfDocumentActions }) => {
        if (hasScrolledToBottom) {
            !showIconsBox &&
                setShowIconsBoxes(prevState => prevState.map((show, index) => (index === documentIndex ? true : show)));
            onScroll({ documentIndex, isAtBottom: true });
        } else {
            if (showIconsBox && hasScrolledOutsideOfDocumentActions) {
                setShowIconsBoxes(prevState =>
                    prevState.map((show, index) => (index === documentIndex ? false : show))
                );
            }
            onScroll({ documentIndex, isAtBottom: false });
        }
    };

    return (
        <div className={`documents__modal-body ${showIconsBox && 'with-icons-box'}`}>
            <div className='documents__modal-information'>
                <FormattedText value='contractsView-dic_readInformation' />
            </div>
            <Carousel activeIndex={currentDocumentIndex} className={`documents__modal-pdf-viewer`}>
                {documentsList.map((document, index) => (
                    <ScrollableDocument
                        key={`document_${document.dmsDocumentType}`}
                        documentIndex={index}
                        pdfContainerRef={pdfContainerRef}
                        file={document.file}
                        onScrollChange={handleScroll}
                    />
                ))}
            </Carousel>
            {showIconsBox && (
                <div className="documents__modal-icons">
                    <button onClick={handlePrintPdf}>
                        <i className={`icons icons--icon-print-blue`} />
                    </button>
                    <button onClick={handleDownload}>
                        <i className={`icons icons--icon-download-blue`} />
                    </button>
                </div>
            )}
        </div>
    );
};
